import React, { forwardRef } from "react";
import styled from "styled-components";
import { flexbox } from "styled-system";
import { StyledBox } from "./Box";
const StyledFlex = styled(StyledBox).withConfig({ displayName: "StyledFlex_APC-7281-productShell", componentId: "sc-1whjzey" })(({ gap, display }) => ({
    display: display ? display : "flex",
    gap,
}), flexbox);
const Flex = forwardRef(function Flex(props, ref) {
    return React.createElement(StyledFlex, Object.assign({}, props, { ref: ref }));
});
export default Flex;
//# sourceMappingURL=Flex.js.map